/**
 * ALGUNAS ENSEÑANZAS — el cierre de las tres secciones de voces.
 *
 * Faina, 26-ago: «la parte de algunas enseñanzas también, en las tres».
 *
 * ⭐ DE DÓNDE SALE CADA UNA, QUE ES LO QUE MÁS IMPORTA AQUÍ:
 *
 *   · ÁNGELES y TRABAJADORES DE LA LUZ → de NUESTRAS PROPIAS canalizaciones,
 *     las 43 y las 3 que ya están publicadas. Son textos co-creados por Faina:
 *     nuestros, sin depender de nadie.
 *   · ESENIOS → del corpus de terceros (Cannon, Meurois, Holzhauser,
 *     Meurois-Givaudan), porque Los Esenios es la única voz esenia SIN piezas
 *     propias y no había de dónde más sacarlas.
 *
 * ⚠️ ESA ASIMETRÍA ES EL PROBLEMA ABIERTO. Faina lo cazó él mismo el 26-ago
 * («¿qué canalizadores tomaste?»): las seis de Esenios vienen de cuatro autores
 * que no han dado permiso, y la página de Agradecimientos promete no nombrarlos
 * sin él. Las de estas dos secciones no tienen ese problema.
 * → Cuando se escriban las 9 piezas de Los Esenios, las suyas pueden salir de
 *   material propio igual que estas, y el asunto se cierra solo.
 *
 * FORMATO, para que las tres cuadren: título de UNA línea (≤ 30 caracteres) y
 * texto de CUATRO (135-160 caracteres). Se iguala recortando, nunca rellenando.
 */

const ESENIOS = [
  {
    clave: 'Compartíamos todo.',
    texto: 'Cuidábamos el cuerpo, compartíamos lo que teníamos, respetábamos a la mujer y '
      + 'venerábamos la naturaleza como la verdadera obra de Dios.',
    fuente: '3110EN0807DN'
  },
  {
    clave: 'El templo empieza adentro.',
    texto: 'Los templos empiezan desde adentro. Si hay plenitud interior, se extiende hacia '
      + 'afuera, y entonces no se necesita ninguna sala para albergarla.',
    fuente: '3110EN0807DN'
  },
  {
    clave: 'Lo cotidiano es medicina.',
    texto: 'Cuando lo haces con amor, hasta lo más pequeño cura. Quien cocina y lava su ropa '
      + 'cantando, pensando en lo divino, nutre con esa alegría todo lo que toca.',
    fuente: '3193EN0807GV'
  },
  {
    /* ⚠️ De Faina (26-ago): la enseñanza destilada sube al título y el verbatim
       entero baja al texto. Es la única en imperativo, y a propósito. */
    clave: 'Crea por amor.',
    texto: 'Quien es capaz de crear, lo hace por amor. Quien se apropia de lo ya creado, lo '
      + 'hace por deseo; en vez de crear una forma, roba una que ya existe.',   // Faina, 20-sep
    fuente: '3178EN0807DG'
  },
  {
    clave: 'El Padre no exige, solo ama.',
    texto: 'Nos creó para la felicidad y la libertad, no para el sufrimiento. Cada alma tiene '
      + 'un lugar propio ante Dios, y ese lugar se puede recuperar siempre.',
    fuente: '3229EN0807DH'
  },
  {
    /* ⚠️ Texto de Faina (26-ago) sobre el verbatim del corpus: no se retoca. */
    clave: 'No vas solo a curar a otros.',
    texto: 'Que tu felicidad no solo sepa manifestarse al contacto con el dolor ajeno. Deja '
      + 'que tu felicidad también te cure a ti: deja que el corazón irradie calor y amor.',
    fuente: '3162EN0807DG'
  }
];

/* LAS SEIS MÁS IMPORTANTES, no una por voz (Faina, 26-ago). La primera versión
   repartía una frase a cada ángel, que es un criterio de reparto y no de valor:
   salían frases medianas solo por representar a su voz. Estas seis se eligieron
   entre las 121 candidatas de las 43 piezas por lo que le dan a quien las lee,
   y da igual de quién sean. Salen cinco voces, y dos son de Los Ángeles porque
   es la que más ha escrito. */
const ANGELES = [
  {
    clave: 'Valiente no es no temer.',
    texto: 'Valiente no es quien no siente miedo: es quien, sintiéndolo y temblando, da el paso '
      + 'igual. La victoria sobre lo que te asusta jamás la conquistarás en una batalla.',   // Faina, 20-sep
    fuente: 'Miguel'
  },
  {
    clave: 'Tras el muro se siente menos.',
    texto: 'Levantaste esos muros para no sufrir, y es verdad que detrás duele menos. Pero '
      + 'también es verdad que detrás se siente menos todo lo demás: la vida misma.',   // Faina, 20-sep
    fuente: 'Chamuel'
  },
  {
    clave: 'Nada es más fuerte que tu amor.',
    texto: 'Cuando alguien te hiere, no está respondiendo solo a lo que pasó entre ustedes. '
      + 'Nada fuera de ti es jamás más poderoso que el amor que vive dentro de ti.',
    fuente: 'Los Ángeles'
  },
  {
    clave: 'Nadie da de una copa vacía.',
    texto: 'Mereces recibir tanto como das. Recibe para que tu manera de dar siga siendo un '
      + 'gozo y no un agotamiento. Nadie puede dar por siempre de una copa vacía.',   // Faina, 20-sep
    fuente: 'Los Ángeles'
  },
  {
    clave: 'Nunca te desconectaste.',
    texto: 'Aunque la vida te haya golpeado y no entiendas por qué, tu energía nunca se ha '
      + 'desconectado de la Fuente. Dios nunca estuvo ausente en tu dolor.',
    fuente: 'Zadquiel'
  },
  {
    clave: 'La oscuridad revela la luz.',
    texto: 'Lo que tu mirada busca por encima de todo no es la oscuridad que rodea a la '
      + 'vela; es la llama. Y cuanto más densa es la oscuridad, más resplandece esa llama.',   // Faina, 20-sep
    fuente: 'Metatrón'
  }
];

/* LAS SEIS MÁS IMPORTANTES **PARA** ELLOS (Faina, 26-ago, y el «para» es la
   clave): no lo que dicen los trabajadores de la luz —que no son una voz— sino
   lo que más falta les hace oír. Salen de las tres piezas propias que existen,
   todas voceadas por Jeshua.
   ⚠️ «No estás por encima de nadie» es la salvaguarda del bloque: sin ella, seis
   mensajes sobre ser distinto y ser pionero se leen como una insignia. */
const TDL = [
  {
    clave: 'No viniste a encajar.',
    texto: 'No viniste a encajar en este mundo, viniste a ayudar a traer uno nuevo. El que '
      + 'viene a transformar algo nunca encaja del todo en eso que vino a cambiar.',
    fuente: '0001LW2107FA'
  },
  {
    clave: 'No estás perdido; estás adelantado.',   // Faina, 20-sep
    texto: 'Cuando te sientas fuera de lugar, recuerda que ir delante no es señal de haberte '
      + 'equivocado de camino: es la señal de que cumples aquello a lo que viniste.',
    fuente: '0022LW2107FA'
  },
  {
    clave: 'Esa añoranza es un don.',
    texto: 'Ese anhelo que te persigue no es una condena ni un dolor. Eres un alma que lleva '
      + 'la memoria del Hogar, esa dimensión de amor puro de donde vienes.',
    fuente: '0021LW2107FA'
  },
  {
    clave: 'El Hogar es una frecuencia.',
    texto: 'No está en ningún mapa que pueda dibujarse. Cada vez que amas sin medida, cada vez '
      + 'que reconoces a un hermano en un extraño, tocas ese Hogar.',
    fuente: '0021LW2107FA'
  },
  {
    clave: 'No estás por encima de nadie.',
    texto: 'Eres un alma pionera, pero no estás por encima de los demás. Hay muchos como tú, '
      + 'dispersos por el mundo, abriendo cada uno su propio tramo de sendero.',
    fuente: '0022LW2107FA'
  },
  {
    clave: 'No escondas tu luz.',
    texto: 'Enciéndela. Otro, a lo lejos, la verá como una antorcha en la oscuridad y se '
      + 'animará a encender la suya. Nadie recupera el Hogar para vivir ausente de aquí.',
    fuente: '0022LW2107FA'
  }
];


/* ─────────────────────────────────────────────────────────────────────────
   LA TIERRA — el cierre de Conservación (Faina, 1-sep).

   «Sacaremos de esos textos seis enseñanzas. Replicaremos lo que hicimos en la
   hoja de menú Esenios al final, donde ponemos 6 enseñanzas y una firma.»

   DE DÓNDE SALEN: de 34 canalizaciones de LA TIERRA recogidas de YouTube —22 a
   través de Pamela Kribbe, el resto de Karolina Zamudio, Valeria Pérez y
   Leticia Breijo—, guardadas como INSUMO en `COCREACION/4 INSUMOS/GAIA (textos
   YouTube)`. **No entran en la biblioteca ni en el corpus**: no son piezas del
   catálogo, son la fuente de estas seis.

   ⚠️ LA MISMA ASIMETRÍA QUE LOS ESENIOS, y hay que decirla: estas seis vienen
   de canalizadores terceros que no han dado permiso, igual que las de Los
   Esenios. Mientras eso no se resuelva, aquí no se les nombra.

   ⚠️ Y LA TIERRA NO ES UNA VOZ DEL SITIO. Faina confirmó el 26-ago que Gaia no
   figura entre las entidades permitidas y la ruta /gaia quedó sin contenido.
   Esto NO la convierte en voz: son enseñanzas al pie de Conservación, sobre la
   tierra que cuidamos, no una sección propia.

   Los textos vienen de transcripción automática, sin un solo signo de
   puntuación: puntuarlos es el único arreglo de forma.

   🔴 Y EN TÚ SINGULAR, NO EN «VOSOTROS» (Faina, 1-sep: «español latinoamericano
   por favor»). Las traducciones de origen mezclan las dos variantes —gaia-011
   está en «ustedes» y gaia-019 en «vosotros»— y la primera versión de estas seis
   arrastró el «vosotros» de unas cuantas. Además de la Def 75, el sitio habla
   siempre de TÚ a una sola persona (Def 40): esa es la forma que vale para
   Latinoamérica y para España a la vez.
   Formato igual que las otras: clave de una línea, texto de 135-160.
   ───────────────────────────────────────────────────────────────────────── */
const TIERRA = [
  {
    clave: 'No estoy muerta.',
    texto: 'Yo misma estoy viviendo la conciencia, no estoy muerta: a cada paso que das '
      + 'puedes sentir el flujo de mi vitalidad bajo tus pies.',
    fuente: 'gaia-016'
  },
  {
    clave: 'La materia está viva.',
    texto: 'Hay conciencia en todo lo que te rodea: la materia es conciencia animada. '
      + 'Siente los árboles, las plantas, la tierra sobre la que estás.',
    fuente: 'gaia-011'
  },
  {
    clave: 'Hay una promesa antigua.',
    texto: 'Estás conectado conmigo por una promesa que se hizo una vez entre la '
      + 'humanidad y yo, el alma de la Tierra. Trata sobre la creación misma.',
    fuente: 'gaia-019'
  },
  {
    /* La que sostiene toda la página: la tierra se conoce con el cuerpo, y por
       eso los Parque Jeshua se abren para caminarlos. */
    clave: 'El cuerpo es el puente.',
    texto: 'Siente mi energía y mi fuerza a través de tu cuerpo físico, y conéctate '
      + 'conmigo: porque tu cuerpo físico es el puente entre tú y yo.',
    fuente: 'gaia-018'
  },
  {
    clave: 'Tu presencia deja huella.',
    texto: 'A menudo subestimas el efecto que ejerces tan solo por estar en algún '
      + 'lugar. Tú los sientes a ellos, y ellos también te sienten a ti.',
    fuente: 'gaia-011'
  },
  {
    clave: 'La flor no duda.',
    texto: '¿Alguna vez has oído hablar de una flor que dude de su destino, o que se '
      + 'cuestione si es libre para alimentarse del suelo, de la lluvia y del sol?',
    fuente: 'gaia-016'
  }
];

export const ENSENANZAS = { esenios: ESENIOS, angeles: ANGELES, tdl: TDL, tierra: TIERRA };

/**
 * La despedida de cada sección. Solo los esenios tienen una comunidad que se
 * despide; las otras dos cierran con sus enseñanzas y nada más — inventarles una
 * voz colectiva que no existe sería justo lo que este proyecto no hace.
 */
export const DESPEDIDA = {
  esenios: { texto: 'Caminamos al lado del mismo sol que tú.', firma: 'Los Esenios' },
  /* La firma de la Tierra sale de sus propias palabras: «yo soy la voz de la
     tierra, estoy bajo vuestros pies» (gaia-001). */
  tierra: { texto: 'Estoy bajo tus pies.', firma: 'La Tierra' }
};
